/**
 * RecipeVideo
 *
 * Used in the RecipeVideo block and recipe_video.blade.php template. Will make
 * an AJAX call to the backend through the Varnish tunnel and provide the video
 * that is to be embedded based on the user's country.
 *
 * @author Tim
 */
export default class RecipeVideo {
    constructor($block) {
        this.$block = $block;
        this.$iframe = this.$block.querySelector('[data-recipe-video]');

        this.updateUrl = this.updateUrl.bind(this);
        this.fetchUrl = this.fetchUrl.bind(this);

        if (this.$iframe) {
            this.updateUrl();
        }
    }

    async updateUrl() {
        const result = await this.fetchUrl();
        if (result.href) {
            this.$iframe.src = result.href;
        }
    }

    async fetchUrl() {
        try {

            /**
             * @see \Core\Blueprints\Block\Recipe\Controller\RecipeVideoController::getVideo()
             *
             * @todo   NOTE: this will always output either a Youtube URL or a GoPlay
             * @todo   URL. Embedding those was identical in LAravel, but in Blueprints
             * @todo   we use a template plugin. If changes are needed, let me know :)
             */
            let url = placeholders.router.request + '/block/' + this.$block.dataset.blockId + '/ajax/get-video/' + this.$iframe.dataset.recipeId;

            const request = await fetch(
                url,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                }
            );

            return await request.json();
        } catch (e) {
            console.log(e);
        }
    }
}
